<template>
  <Dialog 
    :visible="modelValue" 
    @update:visible="$emit('update:modelValue', $event)"
    :modal="true" 
    :showHeader="false" 
    :draggable="false"
    :dismissableMask="true"
    style="width: 24rem; border: none; background: transparent; box-shadow: none;"
    contentStyle="padding: 0; border-radius: 12px; overflow: hidden;"
  >
    <!-- Reset wrapper to guarantee text colors and animations trigger -->
    <div v-if="modelValue" class="dialog-animated-content surface-card border-round-xl overflow-hidden shadow-6">
      
      <!-- Top Decorative Gradient Accent Card -->
      <div class="relative bg-gradient p-5 flex flex-column align-items-center justify-content-center text-center overflow-hidden">
        <div class="glow-blob blob-1"></div>
        <div class="glow-blob blob-2"></div>
        
        <!-- Icon Wrapper with explicit colors -->
        <div class="icon-container flex align-items-center justify-content-center z-1 mb-3">
          <i class="pi pi-rocket text-4xl text-white animated-rocket" style="color: #ffffff !important;"></i>
        </div>
        
        <h3 class="m-0 text-white font-bold text-2xl z-1 tracking-wide" style="color: #ffffff !important;">
          Exciting News!
        </h3>
      </div>

      <!-- Bottom Content Card -->
      <div class="p-4 text-center surface-card flex flex-column align-items-center">
        <p class="m-0 text-lg font-bold mb-2 text-900" style="color: var(--text-color, #333333);">
          "Exam Preparation"
        </p>
        <p class="m-0 text-sm line-height-3 max-w-15rem text-600" style="color: var(--text-color-secondary, #666666);">
          We are crafting something amazing for you. This feature will be live very soon!
        </p>
        
        <!-- Auto-closing indicator bar -->
        <div class="progress-bar-container mt-4">
          <div class="progress-bar" :style="{ animationDuration: duration + 'ms' }"></div>
        </div>
      </div>

    </div>
  </Dialog>
</template>

<script setup>
import { watch, defineProps, defineEmits } from 'vue';
import Dialog from 'primevue/dialog';

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  duration: {
    type: Number,
    default: 3000 
  }
});

const emit = defineEmits(['update:modelValue']);

watch(() => props.modelValue, (isOpen) => {
  if (isOpen) {
    setTimeout(() => {
      emit('update:modelValue', false);
    }, props.duration);
  }
});
</script>

<style scoped>
.dialog-animated-content {
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* Forceful gradient using exact colors if var falls back */
.bg-gradient {
  background: linear-gradient(135deg, var(--primary-color, #77d8d8) 0%, #005f5f 100%) !important;
}

.glow-blob {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  filter: blur(10px);
}
.blob-1 { width: 80px; height: 80px; top: -20px; left: -20px; }
.blob-2 { width: 60px; height: 60px; bottom: -10px; right: -10px; }

.icon-container {
  width: 70px;
  height: 70px;
  background: rgba(255, 255, 255, 0.2) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  border-radius: 50%;
}

/* Fixed Floating Animation */
.animated-rocket {
  display: inline-block !important;
  animation: floatRocket 2.5s ease-in-out infinite !important;
}

@keyframes floatRocket {
  0% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-6px) rotate(5deg); }
  100% { transform: translateY(0px) rotate(0deg); }
}

/* Fixed Progress Bar Countdown */
.progress-bar-container {
  width: 80px;
  height: 4px;
  background: rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: var(--primary-color, #77d8d8) !important;
  width: 100%;
  animation-name: shrinkBar !important;
  animation-timing-function: linear !important;
  animation-fill-mode: forwards !important;
}

@keyframes shrinkBar {
  from { width: 100%; }
  to { width: 0%; }
}

.tracking-wide { letter-spacing: 0.05em; }
.max-w-15rem { max-width: 16rem; }
</style>